import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Informes/deleteSeleccionInformePersonalizado`, method: 'POST', body: values, token: token})
}